import type { LogFilter } from '@/features/log/types/Log';
import type { Filter } from '@/std/hooks/useFilter';
import { LogsTab } from '@/features/log/components/LogsTab';

export function ServicoTabHistoricoAlteracaoGeral({
    enabled,
    filter,
}: {
    enabled?: boolean;
    filter: Filter<LogFilter>;
}) {
    return (
        <div className='flex flex-col gap-2 p-5'>
            <LogsTab enabled={enabled} filter={filter} />
        </div>
    );
}
